"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AppStateConstants_1 = require("../types/AppStateConstants");
const appStateSelectRoutingStackCurrentRouteKey_1 = __importDefault(require("./appStateSelectRoutingStackCurrentRouteKey"));
const appStateMiddlewareCleanListenersAfterRouteKeyChanges = (store) => (next) => (action) => {
    const routeKeyBefore = (0, appStateSelectRoutingStackCurrentRouteKey_1.default)(store.getState());
    const nextAction = next(action);
    const routeKeyAfter = (0, appStateSelectRoutingStackCurrentRouteKey_1.default)(store.getState());
    if (routeKeyBefore !== routeKeyAfter) {
        store.dispatch({
            type: AppStateConstants_1.AppStateConstants.LOCAL_STORAGE_CLEAN_LISTENERS_AND_UPDATES,
        });
    }
    return nextAction;
};
exports.default = appStateMiddlewareCleanListenersAfterRouteKeyChanges;
